import React from 'react';
import { ProductsSection } from '../components/ProductsSection';
import { GallerySection } from '../components/GallerySection';

export const Products: React.FC = () => {
  return (
    <div className="pt-20">
      <ProductsSection />
      <GallerySection />
    </div>
  );
};
